import api from '../../api'
import {
  GET_APROVATION_LIST_SUCCESS,
  GET_APROVATION_LIST_FAILURE,
  GET_APROVATION_FAILURE,
  GET_APROVATION_SUCCESS,
  UPDATE_APROVATION_SUCCESS,
} from '../types'

const state = {
  list: [],
  listUpdated: (new Date()),
  toValidateList: [],
  selected: null,
  selectedUpdated: (new Date())
};


const actions = {

  
  getAprovationList({commit}, query) {
    return new Promise((resolve, reject) => {

    api.startLoader()
    api.getAprovationList(query).then(response => {
      if (!response.ok) {
        api.stopLoader()
        commit(GET_APROVATION_LIST_FAILURE)
        return reject(response.body.$error)

      }
      commit(GET_APROVATION_LIST_SUCCESS, {
        aprovationList: response.body.data
      })
      api.stopLoader()
      return resolve(response.body.data)

    }, response => {
      api.stopLoader()
      commit(GET_APROVATION_LIST_FAILURE)
      return reject(response.body.$error)

    })
  })
  },
 
  cleanAprovationList({commit}) {
    return commit(GET_APROVATION_LIST_FAILURE)
  },
  
  getAprovation({commit}, ud) {
    return new Promise((resolve, reject) => {

      api.getAprovation(ud)
        .then(response => {
          console.log(response);
          if (!response.ok) {
            commit(GET_APROVATION_FAILURE);
            reject();
          }
          commit(GET_APROVATION_SUCCESS, {
            aprovation: response.body
          });
          resolve(response.body);
        }, response => {
          commit(GET_APROVATION_FAILURE);
          reject();
        })
    })
  },
 
  
  updateAprovation({commit}, data) {
    return new Promise((resolve, reject) => {

      api.startLoader()
      let avaliables = [
        "id",
        "AreaId",
        "dateAprovation",
      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }

          api.updateAprovation(obj)
            .then(response => {
              if (!response.ok) {
                api.stopLoader()
                return reject(response.body.$error);
              } else {
                api.stopLoader()
                return resolve(response.body.$success);
              }
            }, response => {
              api.stopLoader()
              return reject(response.body.$error);
            })
      
    })
  },
  createAprovation({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.createAprovation(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },
  
  
 
  deleteAprovation({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteAprovation(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },

  approveAprovation({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.approveAprovation(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },

  rejectAprovation({commit}, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.rejectAprovation(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },
  
};

const mutations = {

  [UPDATE_APROVATION_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.aprovation));
  },
  [GET_APROVATION_LIST_FAILURE](state) {
    state.list = []
  },
  [GET_APROVATION_LIST_SUCCESS](state, action) {
    state.list = action.aprovationList;
    state.listUpdated = new Date();
  },
  [GET_APROVATION_FAILURE](state) {
    state.selected = null
  },
  [GET_APROVATION_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.aprovation));
  },
};

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/aprovation.js